import React from "react";

/**
 * A single skeleton block. Compose with parent flex/grid to build page
 * or table skeletons. `className` should carry width/height utilities.
 */
export function Skeleton({ className = "", testId }) {
  return (
    <div
      className={`animate-pulse rounded-md bg-border-subtle/60 ${className}`}
      data-testid={testId}
    />
  );
}
